export default __webpack_public_path__ + "static/media/menuL_icon_07.7653b983.png";